module.exports = __webpack_public_path__ + "img/logo7.f16de68b.png";